// images.js
import unLoggedWoman_1 from "./unLoggedWoman_1.png";
import unLoggedWoman_2 from "./unLoggedWoman_2.png";
import unLoggedWoman_3 from "./unLoggedWoman_3.png";
import unLoggedWoman_4 from "./unLoggedWoman_4.png";
import unLoggedMan_1 from "./unLoggedMan_1.png";
import unLoggedMan_2 from "./unLoggedMan_2.png";
import unLoggedMan_3 from "./unLoggedMan_3.png";
import unLoggedMan_4 from "./unLoggedMan_4.png";

export const womanImages = [unLoggedWoman_1, unLoggedWoman_2, unLoggedWoman_3, unLoggedWoman_4];
export const manImages = [unLoggedMan_1, unLoggedMan_2, unLoggedMan_3, unLoggedMan_4];
